import { SearchPageProvider } from "@nosto/search-js/preact/serp"
import { AutocompletePageProvider } from "@nosto/search-js/preact/autocomplete"
import { render, useCallback } from "preact/compat"
import Serp from "@/components/Serp/Serp"
import "@/variables.css"
import SearchQueryHandler from "@/components/SearchQueryHandler/SearchQueryHandler"
import { SidebarProvider } from "@/contexts/SidebarContext"
import { autocompleteConfig, categoryConfig, selectors, serpConfig } from "@/config"
import Category from "@/components/Category/Category"
import { CategoryPageProvider } from "@nosto/search-js/preact/category"
import { tagging } from "@/mapping/tagging"
import { nostojs } from "@nosto/nosto-js"
import { ErrorBoundary } from "@nosto/search-js/preact/common"
import Portal from "@/elements/Portal/Portal"
import AutocompleteInjected from "@/components/Autocomplete/AutocompleteInjected"
import { SearchAnalyticsOptions, JSONProduct } from "@nosto/nosto-js/client"
import { searchRedirect } from "./searchRedirect"
// import { useEffect, useState } from "preact/hooks";
// import { SerpElement } from "@nosto/search-js/preact/serp";
// import DynamicCard from "@/elements/DynamicCard/DynamicCard";

type AutocompleteProps = {
  onSubmit: (query: string, options?: SearchAnalyticsOptions) => void
}

function Autocomplete({ onSubmit }: AutocompleteProps) {
  const handleSubmit = useCallback(
    (query: string, options?: SearchAnalyticsOptions) => {
      const trimmedQuery = query.trim()
      if (!trimmedQuery) {
        return
      }
      nostojs(api => api.recordSearchSubmit(trimmedQuery))
      onSubmit(trimmedQuery, options)
    },
    [onSubmit]
  )

  return (
    <AutocompletePageProvider config={autocompleteConfig}>
      <Portal target={selectors.dropdown}>
        <AutocompleteInjected onSubmit={handleSubmit} />
      </Portal>
    </AutocompletePageProvider>
  )
}

function SerpApp() {
  return (
    <ErrorBoundary>
      <SearchQueryHandler />
      <SidebarProvider>
        <Autocomplete onSubmit={searchRedirect} />
        <Portal target={selectors.results} clear>
          <Serp />
        </Portal>
      </SidebarProvider>
    </ErrorBoundary>
  )
}

function CategoryApp() {
  return (
    <ErrorBoundary>
      <SearchQueryHandler />
      <SidebarProvider>
        <Autocomplete onSubmit={searchRedirect} />
        <Portal target={selectors.results} clear>
          <Category />
        </Portal>
      </SidebarProvider>
    </ErrorBoundary>
  )
}

// function ForYou() {
//   const [popularProducts, setPopularProducts] = useState<JSONProduct[]>([]);
//   useEffect(() => {
//     nostojs((api) => {
//       api
//         .defaultSession()
//         .viewFrontPage()
//         .setPlacements(["nosto-curated-for-you"])
//         .load()
//         .then(async (response: any) => {
//           const recommendations = response?.recommendations;
//           if (!recommendations) return;
//           const popular = recommendations["nosto-curated-for-you"];
//           if (popular?.products) {
//             setPopularProducts(popular?.products);
//           }
//         });
//     });
//   }, []);
//   useEffect(() => {
//     console.log("Updated state:", popularProducts);
//   }, [popularProducts]);

//   if (popularProducts.length > 0) {
//     return (
//       <SearchPageProvider config={serpConfig}>
//         <Portal target="#test">
//           <div id="nosto-plp" className="nosto_element is-loaded">
//             <div className="plp">
//               <div className="plp__grid">
//                 {popularProducts.map((product, index) => (
//                   <div className="plp__grid-item" key={product.product_id}>
//                     <SerpElement
//                       as={DynamicCard}
//                       hit={{
//                         productId: product.product_id!,
//                         url: product.url,
//                       }}
//                       componentProps={
//                         {
//                           handle: product.handle!,
//                           section: "nosto-product-tile",
//                           index: index,
//                           itemType: "category",
//                         } as any
//                       }
//                     />
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>
//         </Portal>
//       </SearchPageProvider>
//     );
//   }
// }

function DefaultApp() {
  return (
    <ErrorBoundary>
      <Autocomplete onSubmit={searchRedirect} />
      {/* {window.location.pathname.includes("for-you") && <ForYou />} */}
    </ErrorBoundary>
  )
}

async function init() {
  const api = await new Promise(nostojs)
  // wait for tagging to be available
  await api.pageTaggingAsync()
  const dummy = document.createElement("div")
  switch (tagging.pageType()) {
    case "category":
      render(
        <CategoryPageProvider config={categoryConfig}>
          <CategoryApp />
        </CategoryPageProvider>,
        dummy
      )
      break
    case "search":
      render(
        <SearchPageProvider config={serpConfig}>
          <SerpApp />
        </SearchPageProvider>,
        dummy
      )
      break
    default:
      render(<DefaultApp />, dummy)
      break
  }
}
init()
